import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { useApi } from "~hooks/apiHooks/useApi";
import { useNotification } from "~hooks/useNotification";
import type { FilterParams } from "~pages/Standings/types/filterParams";
import type { DefaultOperationSuccessResponse } from "~types/response";

export const useCreateStanding = (params: FilterParams) => {
  const queryClient = useQueryClient();
  const request = useApi();
  const { sport, organizationId, seasonId } = useParams();

  const { formatMessage } = useIntl();
  const notification = useNotification();
  return useMutation<DefaultOperationSuccessResponse, Error, string>({
    // will be typed after refactoring of create form
    mutationFn: async (body: unknown) => {
      return await request(`${sport}/o/${organizationId}/seasons/${seasonId}/standings`, { method: "POST", body });
    },
    onSuccess: async (response: DefaultOperationSuccessResponse) => {
      if (response?.data && response.data.length > 0 && response.data[0]) {
        await queryClient.invalidateQueries({
          queryKey: ["standings", sport, organizationId, seasonId, params],
        });
        notification.success({
          message: formatMessage({ id: "success" }),
          placement: "bottomRight",
        });
      }
    },
  });
};
